"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataTableView ist die tabellarische Ansicht für die Entity
 *
 */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var styles_1 = require("@mui/styles");
var material_1 = require("@mui/material");
var commonTypes_1 = require("../../shared/types/commonTypes");
var crude_selector_1 = require("../../store/crude/crude.selector");
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var DataTableCell_1 = __importDefault(require("../../screens/DataTableView/DataTableCell"));
var styles_2 = require("@mui/material/styles");
var getCrudeEntityColumns_1 = __importDefault(require("../../shared/util/getCrudeEntityColumns"));
var system_1 = require("@mui/system");
var getDefaultTableFilterSettings_1 = __importDefault(require("../../defaults/getDefaultTableFilterSettings"));
var DataResponsiveRow_1 = __importDefault(require("./DataResponsiveRow"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    table: {
        '& .MuiTableCell-head': {
            backgroundColor: theme.palette.background.paper,
            fontWeight: 700,
            padding: theme.spacing(2),
        },
        '& .MuiTableCell-root': {
            borderBottom: 'none',
        },
    },
    cell: {
        backgroundColor: 'inherit',
    },
    headerCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    moreIcon: {
        color: theme.palette.grey.A400,
        height: '0.7em',
        cursor: 'pointer',
    },
    columnHeaderMenu: {
        position: 'absolute',
        zIndex: 1000,
        width: '200px',
    },
    manageColumnMenu: {
        position: 'absolute',
        zIndex: 1000,
        width: '350px',
    },
    paper: {
        fontSize: theme.typography.caption.fontSize,
    },
    columnHeaderMenuEntry: {
        cursor: 'pointer',
        padding: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            filter: 'brightness(95%)',
        },
    },
    disabledHeaderMenuEntry: {
        cursor: 'default',
        color: theme.palette.grey.A400,
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            filter: 'brightness(100%)',
        },
    },
    columnHeaderMenuEntryIcon: {
        width: '20%',
    },
    columnHeaderMenuEntryText: {
        width: '80%',
    },
    manageColumnsBox: {
        width: '100%',
        padding: '5px 0',
    },
    columnResizeHandle: {
        color: theme.palette.grey.A400,
        marginTop: '0px',
        fontSize: '1.3em',
        cursor: 'col-resize',
        position: 'absolute',
        right: '-18px',
    },
}); });
var DataResponsiveTable = function (props) {
    var _a, _b;
    var t = react_i18next_1.useTranslation().t;
    var dispatch = react_redux_1.useDispatch();
    var classes = useStyles();
    var theme = styles_2.useTheme();
    var dataDisplayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    // manage Licenses
    var configurableTableLicense = crudeLicense.configurableTable.available || false;
    var entity = props.entity;
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var rowsPerPageOptions = appLayout.rowsPerPageOptions || [10, 25, 50, 100];
    var storedEntityColumns = crudeSchema ? getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity) : [];
    var _c = react_1.useState(props.data), data = _c[0], setData = _c[1];
    var _d = react_1.useState(0), dataEntries = _d[0], setDataEntries = _d[1];
    var tableRef = react_1.useRef(null);
    react_1.useEffect(function () {
        props.data && setData(props.data);
        if (props.data && props.data.data) {
            setDataEntries(props.data.data.length);
        }
    }, [props.data]);
    var handleChangePage = function (e, page) {
        var _a, _b;
        var newFilterSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), (_b = {}, _b[props.treeViewLevel] = __assign(__assign({}, storedTableFilterSettings[entity][props.treeViewLevel] || getDefaultTableFilterSettings_1.default()), { page: page }), _b)), _a));
        dispatch(crudeActions.setTableFilterSettings(newFilterSettings));
    };
    var handleChangePageSize = function (e) {
        var _a, _b;
        var newFilterSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), (_b = {}, _b[props.treeViewLevel] = __assign(__assign({}, storedTableFilterSettings[entity][props.treeViewLevel] || getDefaultTableFilterSettings_1.default()), { pageSize: Number.isInteger(Number.parseFloat(e.target.value)) ? Number.parseInt(e.target.value) : storedTableFilterSettings[entity][props.treeViewLevel].pageSize, page: 0 }), _b)), _a));
        dispatch(crudeActions.setTableFilterSettings(newFilterSettings));
    };
    return (react_1.default.createElement(system_1.Box, null,
        (props.treeViewLevel !== 0 &&
            dataDisplayMode !== commonTypes_1.DataDisplayMode.edit &&
            props.dataViewType !== commonTypes_1.DataViewType.referenceView) &&
            react_1.default.createElement(material_1.Grid, { container: true, sx: {
                    padding: '10px',
                    borderBottom: "2px solid " + theme.palette.grey.A200,
                    backgroundColor: theme.palette.background.paper,
                } },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Typography, { variant: 'subtitle1' },
                        react_1.default.createElement("b", null, dataEntries + " " + (((_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity]) === null || _b === void 0 ? void 0 : _b.title) || props.entity) + " " + (dataEntries === 1 ? t('crude:entry') : dataEntries ? t('crude:entries') + " " + t('crude:of') + " " + data.totalElements : ''))))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.TableContainer, { id: 'datatable' },
                react_1.default.createElement(material_1.Table, { size: 'small', className: classes.table, ref: tableRef },
                    react_1.default.createElement(material_1.TableBody, { style: { borderTop: "1px solid " + theme.palette.grey.A400 } }, props && dataEntries !== 0 && (data === null || data === void 0 ? void 0 : data.data.map(function (tableRowData, index) { return (react_1.default.createElement(DataResponsiveRow_1.default, { key: "DataTableRow" + index + props.treeViewLevel, data: data, entity: entity, id: (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn) && tableRowData[entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn], treeViewLevel: props.treeViewLevel, dataViewType: props.dataViewType, tableRef: tableRef, editView: function (view) { return props.editView && props.editView(view); }, reloadTableViewData: function () { return props.reloadTableViewData && props.reloadTableViewData(); } })); }))),
                    react_1.default.createElement(material_1.TableBody, null,
                        dataEntries !== 0 && props.dataViewType === commonTypes_1.DataViewType.referenceView && props.referenceEntity &&
                            Object.keys(data.entityReferencePreviews[props.referenceEntity]).map(function (referenceKey) { return (react_1.default.createElement(material_1.TableRow, { key: "DataTableRow" + referenceKey, onClick: function () { return props.onSelectTableRow && props.onSelectTableRow(referenceKey, props.referenceEntity && data.entityReferencePreviews[props.referenceEntity][referenceKey]); } },
                                react_1.default.createElement(DataTableCell_1.default, { dataViewType: props.dataViewType, align: commonTypes_1.TableTextAlignment.left, entityColumns: storedEntityColumns, treeViewLevel: props.treeViewLevel, content: props.referenceEntity && data.entityReferencePreviews[props.referenceEntity][referenceKey], entity: props.referenceEntity, thumbnailData: props.data.thumbnailData, entityReferencePreviews: props.data.entityReferencePreviews, id: referenceKey }))); }),
                        (dataEntries === 0) &&
                            react_1.default.createElement(material_1.TableRow, { className: 'tableRow', key: 'emptyRow' },
                                react_1.default.createElement(material_1.TableCell, { colSpan: entitySchema && entitySchema.columns.length + 1, align: 'center', style: { borderBottom: '0px' } },
                                    t('crude:noContent'),
                                    storedTableFilterSettings.filter && Object.keys(storedTableFilterSettings.filter).length !== 0 &&
                                        t('crude:resetFilter'))),
                        react_1.default.createElement(material_1.TableRow, null)))),
            data &&
                react_1.default.createElement(material_1.TablePagination, { component: 'div', count: data && data.totalElements, rowsPerPageOptions: props.dataViewType === commonTypes_1.DataViewType.referenceView ? [] : rowsPerPageOptions, rowsPerPage: storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].pageSize : getDefaultTableFilterSettings_1.default().pageSize, page: storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].page : getDefaultTableFilterSettings_1.default().page, backIconButtonProps: {
                        'aria-label': "" + t('crude:lastPage'),
                    }, nextIconButtonProps: {
                        'aria-label': "" + t('crude:nextPage'),
                    }, onPageChange: handleChangePage, onRowsPerPageChange: handleChangePageSize }),
            (data && (data.totalElements <= (storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].pageSize : getDefaultTableFilterSettings_1.default().pageSize))) &&
                react_1.default.createElement("div", null))));
};
exports.default = DataResponsiveTable;
